import { create } from 'zustand';
import { HubMapId, DEFAULT_HUB_MAP_ID } from '../data/hub-map.config';

/**
 * Player positions do **not** go through this store (60 FPS hot path) — they
 * live mutably on `hubService`. Only the map-loaded flag and the current hub
 * map id trigger re-renders here.
 */
interface HubState {
  mapLoaded: boolean;
  /**
   * Which hub map is currently displayed (e.g. bedroom day/night, or any
   * future lore location). Drives skin / collisions / station placement via
   * `HUB_MAPS`. Switched (with a fade) by `hubService.switchMap()`.
   */
  currentHubMapId: HubMapId;
}

interface HubActions {
  setMapLoaded: (loaded: boolean) => void;
  setCurrentHubMapId: (id: HubMapId) => void;
}

export const useHubStore = create<HubState & HubActions>((set) => ({
  mapLoaded: false,
  currentHubMapId: DEFAULT_HUB_MAP_ID,
  setMapLoaded: (loaded) => set({ mapLoaded: loaded }),
  setCurrentHubMapId: (id) => set({ currentHubMapId: id }),
}));
